const thwiftyCat_a = [
  {
    link: "stationary",
    name: "stationary",
    image: "https://cdn.ebtida.com/1704374368517-Stationary.png",
  },
  {
    link: "sports",
    name: "sports",
    image: "https://cdn.ebtida.com/1704374368517-Sports-1.png",
  },
  {
    link: "gaming",
    name: "gaming",
    image: "https://cdn.ebtida.com/1750465966744-games1-thwifty.jpg",
  },
  {
    link: "phone accessories",
    name: "phone_accessories",
    image: "https://cdn.ebtida.com/1704374368517-Phone-Accessories-1.png",
  },
  {
    link: "shoes",
    name: "shoes",
    image: "https://cdn.ebtida.com/1704374368517-Shoes-1.png",
  },
  {
    link: "headphones",
    name: "headphones",
    image: "https://cdn.ebtida.com/1704374368517-Headphones-1.png",
  },
  {
    link: "gaming accessories",
    name: "gaming_accessories",
    image: "https://cdn.ebtida.com/1704374368517-Gaming-Accessories-1.png",
  },
  {
    link: "board games",
    name: "Board Games",
    image: "https://cdn.ebtida.com/1706732527625-Board-Games-x.png",
  },
];

const thwiftyCM = [
  {
    link: "/search/trending",
    image: "https://cdn.ebtida.com/1785869685529-Mobile-1.jpg",
  },
 
 
];

const thwiftyCat_b = [
  {
    link: "sports",
    name: "Sports",
    image: "https://cdn.ebtida.com/1785871737217-Sports01.png",
  },
  {
    link: "health care",
    name: "Health & PersonalCare",
    image: "https://cdn.ebtida.com/1785872113098-Health-&-Personal-Care01.png",
  },
  {
    link: "computers",
    name: "Computers",
    image: "https://cdn.ebtida.com/1785871737217-Computers01.png",
  },
  {
    link: "home & kitchen",
    name: "Home & Kitchen",
    image: "https://cdn.ebtida.com/1785871737217-Home&-kitchen01.png",
  },
  {
    link: "headphones",
    name: "Headphones",
    image: "https://cdn.ebtida.com/1785871737217-Headphone01.png",
  },
  {
    link: "fashion",
    name: "Fashion",
    image: "https://cdn.ebtida.com/1785871737217-Fashion-1.png",
  }
];

const thwiftyCat_c = [
  {
    link: "watches",
    name: "watches",
    image: "https://cdn.ebtida.com/1704374368517-watches-1.png",
  },
  {
    link: "speakers",
    name: "speakers",
    image: "https://cdn.ebtida.com/1704482914220-Speakers-2.png",
  },
  {
    link: "music instruments",
    name: "music_instruments",
    image: "https://cdn.ebtida.com/1704374368517-Music-Instruments.png",
  },
  {
    link: "toys",
    name: "toys",
    image: "https://cdn.ebtida.com/1750465966744-Toys2-thwifty.jpg",
  },
  {
    link: "gaming console",
    name: "gaming_console",
    image: "https://cdn.ebtida.com/1704374368517-Gaming-Consoles-01.png",
  },
];

const thwiftyFashion = [
  {
    link: "watches",
    name: "Watches",
    image: "https://cdn.ebtida.com/1785869685529-Watches.png",
  },
  {
    link: "gaming accessories",
    name: "Gaming Accessories",
    image: "https://cdn.ebtida.com/1785869685529-GamingAccessories.png",
  },
  {
    link: "beauty & cosmetics",
    name: "Beauty&Cosmetics",
    image: "https://cdn.ebtida.com/1785869685529-Beauty&Cosmetics.png",
  },
  {
    link: "electronics",
    name: "Electronics",
    image: "https://cdn.ebtida.com/1785869685529-Electronics.png",
  },
  {
    link: "gaming laptops",
    name: "Gaming Laptops",
    image: "https://cdn.ebtida.com/1785869685529-GamingLaptops.png",
  },
  {
    link: "health and personal care",
    name: "Health & Personal Care",
    image: "https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1769431498973-HealthPersonalCare.jpg",
  },
];

const category_a = thwiftyCat_a;
const category_b = thwiftyCat_b;
const category_c = thwiftyCat_c;
const fashion = thwiftyFashion;
const carousel = thwiftyCM;

const HomeData = {
  category_a: category_a,
  category_b: category_b,
  category_c: category_c,
  fashion: fashion,
  carousel: carousel,
};

export default HomeData;
